<template>
    <div class="claim-modal">
        <el-dialog
            :model-value="WebProfileStore.isEditClaimModalOpen"
            width="700px"
            :show-close="false"
            class="custom-modal"
            @close="close"
            :title="
                $trans('web_profile.claim_for') +
                ' ' +
                (WebProfileStore.profile.name || '')
            "
        >
            <span class="dialog-cancel-text" @click="close">
                {{ $trans("profile_dossier.cancel") }}
                <el-icon><Close /></el-icon>
            </span>
            <el-button
                type="primary"
                @click="save"
                :disabled="!isValidLength"
            >
                {{ $trans("web_profile.save") }}
            </el-button>

            <div class="table-container">
                <el-input
                    id="claimTitle"
                    v-model="localClaimTitle"
                    placeholder="Enter profile header"
                    type="textarea"
                    :rows="2"
                    maxlength="100"
                    resize="vertical"
                />
                <div class="char-counter">
                    <span>{{ localClaimTitle.length }}/100</span>&nbsp;
                    <span>{{ $trans("web_profile.characters_used") }}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import { Close } from "@element-plus/icons-vue";

export default {
    name: "EditClaimModal",
    components: { Close },
    data() {
        return {
            localClaimTitle: "",
        };
    },
    computed: {
        ...mapStores(useWebProfileStore),
        isModalOpen() {
            return this.WebProfileStore.isEditClaimModalOpen;
        },
        isValidLength() {
            return (
                this.localClaimTitle &&
                this.localClaimTitle.length > 0 &&
                this.localClaimTitle.length <= 100
            );
    }   ,
    },
    watch: {
        isModalOpen(newValue) {
            if (newValue) {
                this.localClaimTitle = this.WebProfileStore.profile.claim || "";
            }
        },
    },
    methods: {
        close() {
            this.WebProfileStore.closeEditClaimModal();
        },
        async save() {
            if (!this.localClaimTitle || this.localClaimTitle.length === 0) {
                this.$message.warning(
                    this.$trans("web_profile.enter_claim_title")
                );
                return;
            }
            try {
                await this.WebProfileStore.updateClaim(this.localClaimTitle);
                this.$message.success(this.$trans("web_profile.claim_saved"));
            } catch (error) {
                console.error("Error saving claim:", error);
                this.$message.error(this.$trans("global.something_went_wrong"));
            }
        },
    },
};
</script>

<style scoped>
.claim-modal :deep(.el-dialog) {
    --el-dialog-width: 700px;
    top: -100px !important;
}

:deep(.el-dialog__header) {
    padding-bottom: 40px;
}

.table-container {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 24px;
    padding-top: 10px;
    background-color: #ededed;
    font-family: "Barlow", sans-serif;
    padding-right: 25px;
}

:deep(.el-input) {
    width: 100%;
}

:deep(.el-input__wrapper.is-focus) {
    border: 2px solid #41abc4 !important;
    box-shadow: none !important;
}

.el-button {
    float: right;
    margin-top: -35px;
    background-color: #41abc4;
    border-color: #41abc4;
    border-radius: unset;
    width: 200px;
    font-size: 16px !important;
    font-weight: 700 !important;
}

.dialog-cancel-text {
    position: absolute;
    top: 5px;
    right: 21px;
    cursor: pointer;
    font-size: 14px;
    color: #909399;
    font-weight: 500;
    z-index: 2000;
    user-select: none;
}

.dialog-cancel-text:hover {
    color: #41abc4;
}

.dialog-cancel-text :deep(.el-icon) {
    top: 3px;
    transform: scale(1.4);
}

.char-counter {
    text-align: right;
    font-size: 12px;
    color: #000 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 8px;
}

:deep(.el-textarea__inner) {
    min-width: 100% !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 8px;
    min-height: 70px !important;
}

:deep(.el-dialog__title) {
    font-size: 1.5rem;
}

:deep(.el-button.is-disabled),
:deep(.el-button.is-disabled:hover),
:deep(.el-button.is-disabled:focus) {
    background-color: #bababa !important;
    border-color: #bababa !important;
    color: #ffffff !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
}
</style>
